import React from 'react'
import AwardsSvgs from '../pages/Home/assets/awards.svg?svgr-webpack'
import AwardsMobileSvgs from '../pages/Home/assets/awards-mobile.svg?svgr-webpack'

function Awards() {
  return (
    <div className="mx-auto my-64 w-full max-w-1440 px-40">
      <div className="pb-48 lg:pb-64 lg:pt-0">
        <AwardsSvgs className="hidden max-w-full md:block" />
        <AwardsMobileSvgs className="max-w-full md:hidden" />
      </div>
    </div>
  )
}

export default Awards
